// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b632a66e","453":"2ca3deae","667":"e39ef464","862":"4438f8f0"}[chunkId] + ".chunk.js";
};